// ─── Slate (neutral) ──────────────────────────────────────────────────────────
// Used for backgrounds, borders, text hierarchy
export const SLATE = {
  50: "#f8fafc",
  100: "#f1f5f9",
  200: "#e2e8f0",
  300: "#cbd5e1",
  400: "#94a3b8",
  500: "#64748b",
  600: "#475569",
  700: "#334155",
  800: "#1e293b",
  900: "#0f172a",
};

// ─── Indigo / Brand blue (primary) ────────────────────────────────────────────
// Apple-style blue accent — active states, CTAs, focus rings, nav selection
export const INDIGO = {
  50: "rgba(0,113,227,0.08)",
  100: "rgba(0,113,227,0.15)",
  400: "#5ab0f6",
  500: "#0071e3",
  600: "#0071e3",
  700: "#0077ed",
};

// ─── Blue (secondary / gradient accent) ──────────────────────────────────────
export const BLUE = {
  50: "#eff6ff",
  500: "#3b82f6",
  600: "#2563eb",
  700: "#1d4ed8",
};

// ─── Semantic ─────────────────────────────────────────────────────────────────
export const EMERALD = {
  50: "#ecfdf5",
  500: "#10b981",
  600: "#059669",
};

export const RED = {
  50: "#fef2f2",
  200: "#fecaca",
  300: "#fca5a5",
  600: "#dc2626",
};

export const AMBER = {
  50: "#fffbeb",
  400: "#fbbf24",
  500: "#f59e0b",
  700: "#b45309",
};

// ─── Legacy aliases (kept for backward compatibility with existing pages) ─────
export const COLORS = {
  // Nav
  navLinkText: SLATE[900],
  navBg: SLATE[50],
  navSelected: INDIGO[50],
  navBgOpen: SLATE[100],
  navBgHover: SLATE[50],
  navSubItemActive: SLATE[200],
  border: SLATE[200],

  // Primary palette (updated to match demo)
  PRIMARY_COLOR_1: SLATE[900], // was #0D2855 (dark navy)
  PRIMARY_COLOR_2: INDIGO[600], // was #FF7600 (orange)  → indigo
  PRIMARY_COLOR_3: BLUE[600], // was #327DF6 (blue)    → kept as blue

  // Secondary palette
  SECONDARY_COLOR_1: INDIGO[700],
  SECONDARY_COLOR_2: INDIGO[50],
  SECONDARY_COLOR_3: INDIGO[500],
  SECONDARY_COLOR_4: BLUE[600],
  SECONDARY_COLOR_5: AMBER[400],

  // Neutrals
  NEUTRAL_COLOR_800: SLATE[900],
  NEUTRAL_COLOR_700: SLATE[700],
  NEUTRAL_COLOR_600: SLATE[600],
  NEUTRAL_COLOR_500: SLATE[400],
  NEUTRAL_COLOR_400: SLATE[200],
  NEUTRAL_COLOR_300: SLATE[100],
  NEUTRAL_COLOR_200: SLATE[50],
  NEUTRAL_COLOR_100: "#ffffff",

  // System colors
  SYSTEM_BLUE_400: BLUE[600],
  SYSTEM_BLUE_300: BLUE[500],
  SYSTEM_BLUE_200: "#93c5fd",
  SYSTEM_BLUE_100: BLUE[50],

  SYSTEM_GREEN_400: EMERALD[600],
  SYSTEM_GREEN_300: EMERALD[500],
  SYSTEM_GREEN_200: "#6ee7b7",
  SYSTEM_GREEN_100: EMERALD[50],

  SYSTEM_RED_400: RED[600],
  SYSTEM_RED_300: "#f87171",
  SYSTEM_RED_200: RED[300],
  SYSTEM_RED_100: RED[50],

  SYSTEM_ORANGE_400: AMBER[700],
  SYSTEM_ORANGE_300: AMBER[500],
  SYSTEM_ORANGE_200: "#fcd34d",
  SYSTEM_ORANGE_100: AMBER[50],
};
